'use strict'

export const inputMaskProcessor = {
  methods: {
    applyInputMaskProcessor: function (refKey, mask) {
      // TODO mask validation
      const inputCmp = this.$refs[refKey]
      if (inputCmp && (inputCmp.mask || mask)) {
        let inputEl = inputCmp.$el.querySelector('input')
        if (!inputEl) {
          inputEl = inputCmp.$el.querySelector('textarea')
        }
        if (inputEl) {
          if (!mask) {
            setInputMaskProcessor(inputEl, inputCmp.mask)
          } else {
            setInputMaskProcessor(inputEl, mask)
          }
        }
      }
    }
  }
}

function setInputMaskProcessor (inputEl, mask) {
  inputEl.mask = mask
  const maskNoDataIndexes = [] // 2, 5, 10, 13
  mask.split('').forEach((char, index) => {
    if (char !== '#') {
      maskNoDataIndexes.push(index)
    }
  })
  inputEl.maskNoDataIndexes = maskNoDataIndexes

  // inputEl.addEventListener('input', event => {
  //   let char  = event.data
  //   const inputEl = event.target
  //   // ...
  // })
  inputEl.addEventListener('click', event => selectInputChar(event.target, 0))
  inputEl.addEventListener('keydown', event => {
    if (event.code === 'ArrowRight') {
      selectInputChar(event.target, 1)
    } else if (event.code === 'ArrowLeft') {
      selectInputChar(event.target, -1)
    } else if (parseInt(event.key) >= 0) {
      selectInputChar(event.target)
    }
  })
}

function selectInputChar (inputEl, caretMove) {
  const value = inputEl.value
  let cursorPosition = inputEl.selectionStart
  const configTarget = inputEl // this
  const mask = configTarget.mask
  const maskNoDataIndexes = configTarget.maskNoDataIndexes
  // console.log('' + cursorPosition + ' : ' + inputEl.selectionEnd)
  if (inputEl.selectionEnd - inputEl.selectionStart <= 1) {
    if (caretMove === 0) {
      while (maskNoDataIndexes.includes(cursorPosition)) {
        cursorPosition++
      }
      if (configTarget.prevCursorPosition === cursorPosition && cursorPosition !== inputEl.selectionEnd) {
        if (configTarget.prevCaretMove === -1) {
          cursorPosition++
        }
      }
    // console.log('Cursor: ' + configTarget.prevCursorPosition + ' => ' + cursorPosition)
    } else if (caretMove === 1) {
    // const valIn = cursorPosition
      cursorPosition = configTarget.prevCursorPosition + 1
      // cursorPosition = cursorPosition - 2
      while (maskNoDataIndexes.includes(cursorPosition)) {
        cursorPosition++
      }
    // console.log('Cursor: ' + configTarget.prevCursorPosition + ' => ' + valIn + ' -> ' + cursorPosition)
    } else if (caretMove === -1) {
    // const valIn = cursorPosition
      if (configTarget.prevCursorPosition <= 0) {
        cursorPosition = 0
      } else if (configTarget.prevCursorPosition === mask.length - 1 && configTarget.prevCursorPosition === cursorPosition && cursorPosition === inputEl.selectionEnd) {
        cursorPosition = configTarget.prevCursorPosition
      } else {
        cursorPosition = configTarget.prevCursorPosition - 1
      }
      while (maskNoDataIndexes.includes(cursorPosition)) {
        cursorPosition--
      }
    // console.log('Cursor: ' + configTarget.prevCursorPosition + ' => ' + valIn + ' <- ' + cursorPosition)
    } else if (caretMove === undefined) {
      while (maskNoDataIndexes.includes(cursorPosition)) {
        cursorPosition++
      }
    }
    if (cursorPosition >= mask.length) {
      cursorPosition = mask.length - 1
    }
    configTarget.prevCursorPosition = cursorPosition
    configTarget.prevCaretMove = caretMove
    if (cursorPosition >= 0 && cursorPosition < value.length) {
    // console.log('set: ' + cursorPosition)
      inputEl.selectionStart = cursorPosition
      inputEl.selectionEnd = cursorPosition + 1
    // console.log(inputEl.selectionStart, inputEl.selectionEnd)
    }
  }
}
